import { ButtonHTMLAttributes, PropsWithChildren } from "react";
import { TextButton } from "@/src/components/links/components/TextButton";

type TransferButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export function TransferButton({
  onClick,
}: PropsWithChildren<TransferButtonProps>) {
  return (
    <TextButton size="xs" className="relative z-1 block" onClick={onClick}>
      Transfer
    </TextButton>
  );
}
